<template>
  <div class="title hidden-lg hidden-md">
    {{ title }}
    <!-- <img :src="resourcesUrl + '/home/introduction/title5.png'" alt="" /> -->
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "";
      },
    },
  },
  name:'BannerTitle'
}
</script>
<style scoped lang="less">
.title {
  font-size: 24px;
  margin-bottom: 20px;
  position: relative;
  padding-left: 20px;
  text-align: left;

  &::before {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    content: '';
    width: 3px;
    height: 30px;
    background-color: #e00024;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/yd_title.vue